<template src='./list.pug' lang='pug'></template>

<script>
import PageTitle from '../../../layout/pageTitle/PageTitle'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import VueDragTree from '../../../registration/attributesSet/TreeViewAtt'
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'AttributesSetList',

  components: {
    PageTitle,
    ButtonPrimary,
    VueDragTree,
    ConfirmModal
  },

  data () {
    return {
      attributesSet: [],
      treeViewButtonTitle: {
        config: this.$t('conjuntoAtributo.labels.gerenciar'),
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('conjuntoAtributo.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('planoConciliacao.labels.remover'),
        removeBloq: this.$t('conjuntoAtributo.labels.removerBloqueado')
      },
      linkTypes: [
        {
          type: 'E',
          description: this.$t('conjuntoAtributo.labels.E')
        },
        {
          type: 'MF',
          description: this.$t('conjuntoAtributo.labels.MF')
        },
        {
          type: 'CL',
          description: this.$t('conjuntoAtributo.labels.CL')
        }
      ],
      attSetIdToRemove: null
    }
  },

  computed: {
    canCreate () {
      return this.verifySetTypes()
    }
  },

  methods: {
    // Carrega a listagem de categorias
    loadAttributesSet () {
      this.$store.dispatch('getAttributesSet').then((attributesSetList) => {
        this.attributesSet = attributesSetList
      }).catch((error) => {
        this.$root.$refs.notification.error(error.message)
      })
    },

    // Método chamando nos botões do componente TreeViewAtt
    createEditAttribute (attributeId, set, isEdit) {
      if (isEdit) {
        trackAnalyticsEvent(this, 'attribute-click', 'edit-attribute', attributeId)
        this.editAttribute(attributeId, set)
      }
    },

    newAttribute (set) {
      this.$store.dispatch('clearEditAttributeSet')
      this.$store.dispatch('setAttributesSetList', this.attributesSet)
      this.$router.push(PATHS.NEW_ATTRIBUTES_SET)
    },

    // Método que edita um atributo
    editAttribute (attributeId, set) {
      this.$store.dispatch('getAttributeSetById', attributeId)
        .then(attributeSet => {
          this.$store.dispatch('setAttributesSetToEdit', attributeSet)
          this.$store.dispatch('setAttributesSetList', this.attributesSet)
          this.$router.push(PATHS.NEW_ATTRIBUTES_SET)
        })
        .catch(error => this.$root.$refs.notification.error(error.message))
    },

    handleRemove (attSetIdToRemove) {
      this.attSetIdToRemove = attSetIdToRemove
      $('#confirmRemoveAttSet').modal('show')
    },

    removeAttSet () {
      trackAnalyticsEvent(this, 'remove-click', 'remove-att-cfg', 'remove-att-cfg')
      if (this.attSetIdToRemove) {
        this.$store.dispatch('removeAttributeSet', this.attSetIdToRemove)
          .then((response) => {
            this.$root.$refs.notification.success('conjuntoAtributo.sucesso.remover')
            this.attSetIdToRemove = null
            $('#confirmRemoveAttSet').modal('hide')
            this.loadAttributesSet()
            this.$store.dispatch('clearAttributeList')
            this.$store.dispatch('clearEditAttributeSet')
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error.message)
          })
      }
    },

    closeModalConfirm () {
      this.attSetIdToRemove = null
      $('#confirmRemoveAttSet').modal('hide')
    },

    verifySetTypes () {
      let aviables = this.linkTypes.filter(type => {
        let link = this.attributesSet.find(item => item.linkType === type.type)
        return link === undefined || link === null
      })
      return aviables && aviables.length > 0
    }
  },

  created () {
    this.loadAttributesSet()
    this.$store.dispatch('clearAttributeList')
    this.$store.dispatch('clearEditAttributeSet')
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?2c86300a